export default {
  data: () => ({
    t: null,
  }),
  methods: {
    rt_previous() {
      this.$router.back();
    },
    rt_replace(path) {
      if (this.$route.path !== path) {
        this.$router.replace(path, () => {}, () => {});
      }
    },
    rt_push(path) {
      if (this.$route.path !== path) {
        this.$router.push(path, () => {}, () => {});
      }
    },
  },
};
